// @ts-nocheck

import React from 'react';
import { useMemo } from 'react';
import styled from 'styled-components';

import { __ } from '../../../../i18n/l10n';
import colors from '../../../../styled-components/palette';
import { BoomHalloweenWelcomeBombImgPath } from '../../assets/img';
import { BoomLabelsBySkinId } from '../../constants/labels';
import { useBoomContext } from '../../contexts/BoomContext';
import { useBoomViewContext } from '../../contexts/BoomViewContext';
import BoomBoxWrapper from '../common/BoomBoxWrapper';
import BoomPrimaryButton from '../common/BoomPrimaryButton';

const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  flex-direction: row;
  z-index: 10;
  height: ${({ $height }) => ($height ? `${$height}px` : 'auto')};
`;

const MessageWrapper = styled(BoomBoxWrapper)`
  position: absolute;
  z-index: 2;
  bottom: 0.6em;
  left: 0.6em;
  right: 0.6em;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.6em;
`;

const Title = styled.div`
  font-family: 'ChangaOne', sans-serif;
  color: #fff;
  font-size: 1.7em;
  margin-left: 0.6em;
`;

const TitleImg = styled.img`
  height: 4.2em;
`;

const Content = styled.div`
  color: ${colors.bluegrey200};
  font-size: 1em;
  margin-bottom: 1em;
  line-height: 1.8em;
`;

const StyledBoomPrimaryButton = styled(BoomPrimaryButton)``;

type BoomWelcomeProps = {
  className?: string;
  onClick: () => void;
};

const BoomWelcome = ({ className = '', onClick }: BoomWelcomeProps) => {
  const { height } = useBoomViewContext();

  const { skinId } = useBoomContext();

  const welcomeContentText = useMemo(() => BoomLabelsBySkinId[skinId]?.WelcomeContent ?? '', [skinId]);

  return (
    <Wrapper className={className} $height={height}>
      <MessageWrapper>
        <TitleWrapper>
          <TitleImg src={BoomHalloweenWelcomeBombImgPath} />
          <Title>{__('!noun:Welcome')}</Title>
        </TitleWrapper>
        <Content>
          <div>{__('Your mission is simple:')}</div>
          <div>{welcomeContentText}</div>
          <div>💸 {__('Win a ton of Freebets along the way!')}</div>
        </Content>
        <StyledBoomPrimaryButton onClick={onClick} skinId={skinId}>
          {__('Ok')}
        </StyledBoomPrimaryButton>
      </MessageWrapper>
    </Wrapper>
  );
};

export default BoomWelcome;
